var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[(_vm.hasAvatar)?_c('img',{staticClass:"avatar__img",attrs:{"src":_vm.src,"alt":"Avatar"}}):_c('div',{staticClass:"avatar__default"},[_c('v-icon-avatar')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }